import 'core-js/features/array/at';
import '@trashlab/sitesapp/src/main/node-globals';
import '@trashlab/sitesapp/src/env';
import { Theme } from '@radix-ui/themes';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { httpLink } from '@trpc/client';
import ReactDOM from 'react-dom/client';
import { transformer } from '@trashlab/api/transformer';

import { HelmetProvider } from 'react-helmet-async';

import { trpc } from '@trashlab/api/src/library/frontend/utils/trpc';
import { registerSuperJSONTransformers } from '@trashlab/api/src/shared/data/superjson-transformers';
import env from '@trashlab/sitesapp/src/env';

import '@trashlab/sitesapp/src/routes';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';

registerSuperJSONTransformers();

const router = createRouter({
  routeTree: rootRoute,
  context: 'DEFAULT',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchIntervalInBackground: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchInterval: 600 * 1000,
      staleTime: 6000 * 1000,
      retry: false,
      structuralSharing: false,
    },
  },
});

const TrpcClient = trpc.createClient({
  links: [
    httpLink({
      url: `${env.NEXT_PUBLIC_API_HOST || env.NEXT_PUBLIC_APP_HOST}/api/trpc`,
    }),
  ],
  transformer,
});

const rootElement = document.getElementById('root')!;

// Old cached SSR responses may still include the removed SEO snapshot during
// deploy transitions. Clear only that known fallback so React can boot.
if (rootElement.querySelector('[data-sitesapp-seo-snapshot]')) {
  rootElement.replaceChildren();
}

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <Theme appearance="light">
      <trpc.Provider client={TrpcClient} queryClient={queryClient}>
        <QueryClientProvider client={queryClient}>
          <HelmetProvider>
            <RouterProvider router={router} />
          </HelmetProvider>
        </QueryClientProvider>
      </trpc.Provider>
    </Theme>,
  );
}
